<base-dialog-template [dialogHidden]="dialogHidden" (onClose)="close()">

  <ng-container heading *ngIf="title">{{title}}</ng-container>

</base-dialog-template>
